import { useSelector } from 'react-redux';

import { selectors as checkErrorServiceDialogSelectors } from '../../redux/check-error-service-dialog';

const useOpen = () => useSelector(checkErrorServiceDialogSelectors.selectOpen);

const hooks = { useOpen };

export default hooks;
